import {Card, CardHeader, CardBody, Progress, Divider, Image} from "@nextui-org/react";
import {useTranslation} from "react-i18next";

const ReferencesPage = () => {
    const {t} = useTranslation();
    
    const references = [
        {
            id: "tpao",
            imgUrl: "https://cdn.memleket.com.tr/news/304254.jpg"
        },
        {
            id: "mercedes",
            imgUrl: "https://img1.cgtrader.com/items/4060860/05ef4c642c/large/mercedes-benz-logo-3d-3d-model-05ef4c642c.jpg"
        },
        {
            id: "mobiliz",
            imgUrl: "https://play-lh.googleusercontent.com/ol6-4-2w551jO7cjr1gQOHFeO_DaCXJoB7oMuAUpWbxP5NVBg4G_saVjyCdEoR5S0A"
        },
        {
            id: "transpet",
            imgUrl: "https://nakkasholding.com.tr/media/b3jbipee/transpet.png"
        },
        {
            id: "global",
            imgUrl: "https://nakkasholding.com.tr/media/ggwg2dlf/global_gaz.png"
        }
    ];
    
    return(
        <div>
            <section className="bg-white dark:bg-gray-900 bg-[url('https://flowbite.s3.amazonaws.com/docs/jumbotron/hero-pattern.svg')] dark:bg-[url('https://flowbite.s3.amazonaws.com/docs/jumbotron/hero-pattern-dark.svg')]">
                <div className="py-8 px-4 mx-auto max-w-screen-xl text-center lg:py-16 z-10 relative">
                    <h1 className="mb-4 text-4xl font-extrabold tracking-tight leading-none md:text-5xl lg:text-6xl">
                        {t("references.title")}
                    </h1>
                    <div className="flex justify-center my-5">
                        <Progress
                            size="sm"
                            color="danger"
                            isIndeterminate
                            aria-label="Loading..."
                            className="max-w-md"
                        />
                    </div>
                    <p className="mb-8 text-lg font-normal lg:text-xl max-w-4xl mx-auto">
                        {t("referencesDesc")}
                    </p>
                    <Divider className="my-4" />
                    
                    <div className="mt-20 pb-20">
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                            {references.map((reference) => (
                                <Card 
                                    key={reference.id} 
                                    className="py-4 bg-background/60 dark:bg-default-100/50 backdrop-blur-sm hover:scale-105 transition-transform"
                                    isPressable
                                >
                                    <CardHeader className="pb-0 pt-2 px-4 flex-col items-center">
                                        <div className="w-full h-72 overflow-hidden rounded-xl mb-4 flex items-center justify-center p-4">
                                            <Image
                                                alt={t(`references.list.${reference.id}.name`)}
                                                className={`object-contain w-full h-full transition-transform ${
                                                    reference.id === "transpet" || reference.id === "global" 
                                                    ? "w-72 h-72" 
                                                    : ""
                                                }`}
                                                src={reference.imgUrl}
                                            />
                                        </div>
                                        <h4 className="font-bold text-2xl mb-2">
                                            {t(`references.list.${reference.id}.name`)}
                                        </h4>
                                        <div className="bg-primary/10 dark:bg-primary/20 rounded-full px-4 py-1">
                                            <p className="text-primary dark:text-primary-500 font-semibold">
                                                {t(`references.list.${reference.id}.partnership`)}
                                            </p>
                                        </div>
                                    </CardHeader>
                                    <CardBody className="overflow-visible py-4 px-6 text-center">
                                        <p className="text-default-600 text-base leading-relaxed">
                                            {t(`references.list.${reference.id}.desc`)}
                                        </p>
                                    </CardBody>
                                </Card>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="bg-gradient-to-b from-red-200 to-transparent dark:from-red-950 w-full h-full absolute top-0 left-0 z-0"></div>
            </section>
        </div>
    );
};

export default ReferencesPage;